(function() {
  'use strict';

  var namespace = window.BestTuningVehicleFilter = window.BestTuningVehicleFilter || {};
  namespace.initialized = namespace.initialized || {};

  function normalizeExactTag(tag) {
    return (tag || '').toString().trim().toLowerCase();
  }

  function inferUnambiguousProductCategory(productTags, categories) {
    if (!Array.isArray(productTags) || !Array.isArray(categories)) return null;

    var exactProductTags = {};
    var matchesByHandle = {};
    var matches = [];

    for (var i = 0; i < productTags.length; i++) {
      var exactTag = normalizeExactTag(productTags[i]);
      if (exactTag) exactProductTags[exactTag] = true;
    }

    for (var j = 0; j < categories.length; j++) {
      var category = categories[j];
      var handle = normalizeExactTag(category && (category.handle || category.value));

      if (!category ||
          !handle ||
          Number(category.productCount || 0) < 1 ||
          exactProductTags[handle] !== true ||
          matchesByHandle[handle]) {
        continue;
      }

      matchesByHandle[handle] = true;
      matches.push(category);
    }

    return matches.length === 1 ? matches[0] : null;
  }

  namespace.inferUnambiguousProductCategory = inferUnambiguousProductCategory;

  function parseConfig(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      console.error('Fahrzeugfilter Konfiguration Fehler:', error);
      return null;
    }
  }

  namespace.init = function(config) {
    if (!config) return;

    var sid = String(config.sid || '');
    if (!sid) return;
    if (namespace.initialized[sid]) return;
    namespace.initialized[sid] = true;
    var root = document.getElementById('bt-ymm-' + sid);
    if (!root) {
      namespace.initialized[sid] = false;
      return;
    }

    var toggleBtn = document.getElementById('btToggleFilter-' + sid);
    var DATA_URL = config.dataUrl || '';
    var AVAILABILITY_URL = config.availabilityUrl || '';
    var searchBtn = document.getElementById('btSearch-' + sid);
    var resetBtn = document.getElementById('btReset-' + sid);
    var makeSelect = document.getElementById('btMakeSelect-' + sid);
    var modelSelect = document.getElementById('btModelSelect-' + sid);
    var yearSelect = document.getElementById('btYearSelect-' + sid);
    var categorySelect = document.getElementById('btCategorySelect-' + sid);
    var productTags = Array.isArray(config.productTags) ? config.productTags : [];

    var STORAGE_KEY = 'bt_selected_vehicle';
    var COLLECTION_TAG_ALIASES = {
      'audi-a3-8p-3-turer-2003-2012': 'audi-a3-8p-3-turer-8p-3-turer-2003-2012',
      'audi-a3-8v-cabriolet-2014-2020': 'audi-a3-8v-cabriolet-8v-cabriolet-2014-2020',
      'audi-a3-8v-limousine-2013-2020': 'audi-a3-8v-limousine-8v-limousine-2013-2020',
      'audi-a3-8y-2020': 'audi-a3-8y-8y-2020',
      'audi-90-b2-1984-1987': 'audi-90-b2-b2-1984-1987',
      'audi-s3-8pa-sportback-2008-2012': 'audi-s3-8p-sportback-2008-2012',
      'audi-s6-plus-q1-1996-1997': 'audi-s6-plus-q1-q1-1996-1997',
      'bmw-8er-g14-cabriolet-2018': 'bmw-8er-g14-m8-cabriolet-2018',
      'bmw-8er-g15-coupe-2018': 'bmw-8er-g15-m8-coupe-2018',
      'bmw-8er-g16-gran-coupe-2018': 'bmw-8er-g16-m8-gran-coupe-2018',
      'fiat-500-500': 'fiat-500-2007',
      'fiat-fiorino-alle-produkte': 'fiat-fiorino',
      'ford-c-max-c-max-grand-c-max-ii-2010': 'ford-c-max-grand-c-max-ii-2010',
      'ford-mustang-mustang-mach-e': 'ford-mustang-mach-e',
      'jeep-grand-cherokee-1993-1998': 'jeep-grand-cherokee',
      'land-rover-discovery-discovery-sport-2015': 'land-rover-discovery-sport-2015',
      'mazda-cx-cx-3-2015-2022': 'mazda-cx-3-2015-2022',
      'mazda-cx-cx-5-ke-2011-2017': 'mazda-cx-5-ke-2011-2017',
      'mazda-cx-cx-60-2022': 'mazda-cx-60-2022',
      'mazda-cx-cx-7-2006-2012': 'mazda-cx-7-2006-2012',
      'mercedes-8-w114-w115-1968-1976': 'mercedes-8-w114-w115-19681976',
      'mitsubishi-lancer-1988-1992': 'mitsubishi-lancer-4-1988-1992',
      'mitsubishi-lancer-1996-2003': 'mitsubishi-lancer-6-1996-2003',
      'mitsubishi-lancer-2003-2007': 'mitsubishi-lancer-7-2003-2007',
      'mitsubishi-lancer-2007-2017': 'mitsubishi-lancer-8-2007-2017',
      'renault-megane-megane-scenic-1996-2003': 'renault-megane-megane-scenic-megane-scenic-1996-2003',
      'seat-cordoba-6k-1993-1999': 'seat-coedoba-6k-1993-1999',
      'seat-cordoba-6k2-1999-2002': 'seat-coedoba-6k2-1999-2002',
      'seat-cordoba-6l-2002-2008': 'seat-coedoba-6l-2002-2008'
    };
    var SEARCH_FALLBACK_TAGS = {
      'mitsubishi-lancer-1991-1996': true,
      'skoda-superb-iii-3v-2015-2023': true,
      'subaru-impreza-vi-2023': true
    };

    function normalizeCollectionTag(tag) {
      tag = (tag || '').toString().trim();
      return COLLECTION_TAG_ALIASES[tag] || tag;
    }

    function redirectAliasedCollectionPath() {
      var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
      if (!match) return;

      var currentHandle = decodeURIComponent(match[1] || '');
      var normalizedHandle = normalizeCollectionTag(currentHandle);
      if (!normalizedHandle || normalizedHandle === currentHandle) return;

      var params = new URLSearchParams(window.location.search);
      if (params.get('bt_tag') === currentHandle) {
        params.set('bt_tag', normalizedHandle);
      }

      var query = params.toString();
      window.location.replace('/collections/' + encodeURIComponent(normalizedHandle) + (query ? '?' + query : ''));
    }

    redirectAliasedCollectionPath();

    var isHomePage =
      window.location.pathname === '/' ||
      window.location.pathname === (config.rootUrl || '/');

    if (isHomePage) {
      localStorage.removeItem(STORAGE_KEY);
    }

    var vehicleTree = {};
    var rows = [];
    var availability = { vehicles: {}, handles: {} };
    var availabilityByHandle = {};

    var current = {
      make: '',
      model: '',
      year: '',
      tag: '',
      categorySlug: '',
      categoryLabel: '',
      collectionHandle: ''
    };

    var UNIVERSAL_MAKE_VALUE = '__universal__';
    var universalCategories = Array.isArray(config.universalCategories)
      ? config.universalCategories.filter(function(item) { return item && item.handle && item.label; })
      : [];
    var isUniversalMode = false;
    var filterRow = document.getElementById('btFilterRow-' + sid);

    function slugify(text) {
      return (text || '')
        .toString()
        .toLowerCase()
        .replace(/\u00df/g, 'ss')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function buildTag(make, model, year) {
      var generatedTag = slugify(make + '-' + model + '-' + year);
      return normalizeCollectionTag(generatedTag);
    }

    function saveSelection() {
      if (!current.make || !current.model || !current.year || !current.tag) return;

      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        make: current.make,
        model: current.model,
        year: current.year,
        tag: current.tag,
        categorySlug: current.categorySlug,
        categoryLabel: current.categoryLabel,
        collectionHandle: current.collectionHandle
      }));
    }

    function getSavedSelection() {
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        if (saved && saved.make && saved.model && saved.year && saved.tag) return saved;
      } catch(e) {}
      return null;
    }

    function clearSavedSelection() {
      localStorage.removeItem(STORAGE_KEY);
    }

    function getNormalizedProductTags() {
      var normalized = {};

      for (var i = 0; i < productTags.length; i++) {
        var rawTag = (productTags[i] || '').toString().trim().toLowerCase();
        var cleanTag = normalizeCollectionTag(slugify(rawTag));

        if (rawTag) normalized[rawTag] = true;
        if (cleanTag) normalized[cleanTag] = true;
      }

      return normalized;
    }

    function productMatchesSelection(saved, selectedCategory) {
      if (!saved || !selectedCategory || !productTags.length) return false;

      var normalizedTags = getNormalizedProductTags();
      var vehicleTag = normalizeCollectionTag(saved.tag || '');
      var categoryTag = normalizeCollectionTag(selectedCategory.handle || '');

      return !!vehicleTag &&
        !!categoryTag &&
        normalizedTags[vehicleTag] === true &&
        normalizedTags[categoryTag] === true;
    }

    function inferProductCategory(row) {
      if (!row || !row.tag || !productTags.length) return null;

      var inferred = inferUnambiguousProductCategory(productTags, getCategories(row.tag));
      if (!inferred) return null;

      var category = findCategoryByHandle(inferred.handle || inferred.value || '');
      if (!category || category.vehicleTag !== row.tag) return null;

      return category;
    }

    function buildProductUrlWithSelection(href) {
      if (!href ||
          !current.make ||
          !current.model ||
          !current.year ||
          !current.tag ||
          !current.categorySlug ||
          !current.collectionHandle) {
        return '';
      }

      try {
        var url = new URL(href, window.location.origin);

        if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) {
          return '';
        }

        url.searchParams.set('bt_make', current.make);
        url.searchParams.set('bt_model', current.model);
        url.searchParams.set('bt_year', current.year);
        url.searchParams.set('bt_tag', current.tag);
        url.searchParams.set('bt_category', current.categorySlug);

        return url.pathname + (url.search ? url.search : '') + (url.hash ? url.hash : '');
      } catch (error) {
        return '';
      }
    }

    function decorateProductLink(link) {
      if (!link || !link.getAttribute) return;

      var decoratedHref = buildProductUrlWithSelection(link.getAttribute('href') || '');

      if (decoratedHref) {
        link.setAttribute('href', decoratedHref);
      }
    }

    function decorateProductLinks() {
      var links = document.querySelectorAll('a[href*="/products/"]');

      for (var i = 0; i < links.length; i++) {
        decorateProductLink(links[i]);
      }
    }

    function persistSelectionOnProductPage() {
      if (window.location.pathname.indexOf('/products/') !== 0) return;

      var nextUrl = buildProductUrlWithSelection(window.location.href);
      var currentUrl = window.location.pathname + window.location.search + window.location.hash;

      if (nextUrl && nextUrl !== currentUrl && window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', nextUrl);
      }
    }

    function persistCategoryContext() {
      if (!current.categorySlug || !current.collectionHandle) return;

      persistSelectionOnProductPage();
      decorateProductLinks();

      setTimeout(decorateProductLinks, 0);
      setTimeout(decorateProductLinks, 800);
    }

    function closeAllDropdowns() {
      var all = root.querySelectorAll('.bt-dd');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.remove('is-open');
      }
    }

    function createDropdown(config) {
      var wrap = root.querySelector(config.wrapSelector);
      var trigger = root.querySelector(config.triggerSelector);
      var menu = root.querySelector(config.menuSelector);

      var state = {
        value: '',
        items: [],
        disabled: true
      };

      function setDisabled(disabled) {
        state.disabled = !!disabled;
        trigger.disabled = !!disabled;
        wrap.classList.toggle('bt-dd-disabled', !!disabled);
        if (disabled) wrap.classList.remove('is-open');
      }

      function setText(text) {
        var textEl = trigger.querySelector('.bt-dd-text');
        if (textEl) textEl.textContent = text || config.placeholder;
      }

      function setValue(value) {
        state.value = value || '';
      }

      function setItems(items) {
        state.items = items || [];
        renderMenu();
      }

      function renderMenu() {
        menu.innerHTML = '';

        var optionsWrap = document.createElement('div');
        optionsWrap.className = 'bt-dd-options';

        if (!state.items.length) {
          var empty = document.createElement('div');
          empty.className = 'bt-dd-empty';
          empty.textContent = 'Keine Treffer';
          optionsWrap.appendChild(empty);
        } else {
          var placeholderBtn = document.createElement('button');
          placeholderBtn.type = 'button';
          placeholderBtn.className = 'bt-dd-option bt-dd-placeholder';
          placeholderBtn.setAttribute('data-value', '');
          placeholderBtn.textContent = config.placeholder || '';
          optionsWrap.appendChild(placeholderBtn);

          for (var i = 0; i < state.items.length; i++) {
            var item = state.items[i];

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'bt-dd-option';
            btn.setAttribute('data-value', item.value);
            btn.textContent = item.label;

            if (item.value === UNIVERSAL_MAKE_VALUE) {
              btn.classList.add('is-universal');
            }

            if (state.value && state.value === item.value) {
              btn.classList.add('is-selected');
            }

            optionsWrap.appendChild(btn);
          }
        }

        menu.appendChild(optionsWrap);
      }

      function getOptions() {
        return Array.prototype.slice.call(menu.querySelectorAll('.bt-dd-option'));
      }

      function setActiveOption(index) {
        var options = getOptions();
        if (!options.length) return;

        if (index < 0) index = options.length - 1;
        if (index >= options.length) index = 0;

        for (var i = 0; i < options.length; i++) {
          options[i].classList.toggle('is-active', i === index);
        }

        options[index].scrollIntoView({ block: 'nearest' });
      }

      function getActiveIndex() {
        var options = getOptions();
        for (var i = 0; i < options.length; i++) {
          if (options[i].classList.contains('is-active')) return i;
        }
        for (var j = 0; j < options.length; j++) {
          if (options[j].classList.contains('is-selected')) return j;
        }
        return -1;
      }

      function chooseActiveOption() {
        var options = getOptions();
        if (!options.length) return;

        var index = getActiveIndex();
        if (index < 0) index = 0;

        var option = options[index];
        var value = option.getAttribute('data-value') || '';
        var label = option.textContent || '';

        close();
        select(value, label);
      }

      function normalizeKeyboardSearch(text) {
        return (text || '')
          .toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      }

      function activateOptionByLetter(letter) {
        letter = normalizeKeyboardSearch(letter);
        if (!letter) return false;

        var allOptions = getOptions();
        var options = [];

        for (var i = 0; i < allOptions.length; i++) {
          if (!allOptions[i].classList.contains('bt-dd-placeholder')) {
            options.push(allOptions[i]);
          }
        }

        if (!options.length) return false;

        var currentIndex = -1;

        for (var j = 0; j < options.length; j++) {
          if (options[j].classList.contains('is-active')) {
            currentIndex = j;
            break;
          }
        }

        if (currentIndex < 0) {
          for (var k = 0; k < options.length; k++) {
            if (options[k].classList.contains('is-selected')) {
              currentIndex = k;
              break;
            }
          }
        }

        for (var n = 1; n <= options.length; n++) {
          var index = (currentIndex + n + options.length) % options.length;
          var optionText = normalizeKeyboardSearch(options[index].textContent || '');

          if (optionText.charAt(0) === letter) {
            for (var a = 0; a < allOptions.length; a++) {
              allOptions[a].classList.remove('is-active');
            }

            options[index].classList.add('is-active');
            options[index].scrollIntoView({ block: 'nearest' });
            return true;
          }
        }

        return false;
      }

      function open() {
        if (state.disabled) return;
        closeAllDropdowns();
        wrap.classList.add('is-open');
        renderMenu();

        if (trigger && typeof trigger.focus === 'function') {
          try {
            trigger.focus({ preventScroll: true });
          } catch(e) {
            trigger.focus();
          }
        }

        setTimeout(function() {
          var index = getActiveIndex();
          setActiveOption(index >= 0 ? index : 0);
        }, 0);
      }

      function close() {
        wrap.classList.remove('is-open');
      }

      function select(value, label) {
        setValue(value);
        setText(label || config.placeholder);

        if (typeof config.onChange === 'function') {
          config.onChange(value, label || '');
        }
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();

        if (state.disabled) return;

        if (wrap.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (state.disabled) return;

        var key = (e.key || '').toLowerCase();
        var isOpen = wrap.classList.contains('is-open');

        if (key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
          e.preventDefault();

          if (!isOpen) {
            open();

            setTimeout(function() {
              activateOptionByLetter(key);
            }, 0);
          } else {
            activateOptionByLetter(key);
          }

          return;
        }

        if (key === 'arrowdown' || key === 's' || key === 'w' || key === 'arrowup') {
          e.preventDefault();

          if (!isOpen) {
            open();
            return;
          }

          var currentIndex = getActiveIndex();

          if (key === 'arrowdown' || key === 's') {
            setActiveOption(currentIndex + 1);
          } else {
            setActiveOption(currentIndex - 1);
          }
        }

        if (key === 'enter' || key === ' ') {
          e.preventDefault();

          if (!isOpen) {
            open();
          } else {
            chooseActiveOption();
          }
        }

        if (key === 'escape') {
          close();
        }
      });

      menu.addEventListener('click', function(e) {
        var option = e.target.closest('.bt-dd-option');
        if (!option) return;

        var value = option.getAttribute('data-value') || '';
        var label = option.textContent || '';

        close();
        select(value, label);
      });

      return {
        setDisabled: setDisabled,
        setItems: setItems,
        setValue: setValue,
        setText: setText,
        open: open,
        close: close
      };
    }

    function fillNativeSelect(select, items, placeholder) {
      if (!select) return;

      select.innerHTML = '';

      var first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);

      (items || []).forEach(function(item) {
        var value = typeof item === 'object' ? item.value : item;
        var label = typeof item === 'object' ? item.label : item;

        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = label;
        select.appendChild(opt);
      });
    }

    function syncNativeSelects() {
      if (!makeSelect || !modelSelect || !yearSelect || !categorySelect) return;

      fillNativeSelect(makeSelect, getMakes(), 'Marke auswählen');
      makeSelect.value = isUniversalMode ? UNIVERSAL_MAKE_VALUE : (current.make || '');

      if (isUniversalMode) {
        fillNativeSelect(
          modelSelect,
          universalCategories.map(function(item) { return { value: item.handle, label: item.label }; }),
          'Kategorie auswählen'
        );
        modelSelect.disabled = universalCategories.length === 0;
        modelSelect.value = current.collectionHandle || '';

        fillNativeSelect(yearSelect, [], 'Jahr auswählen');
        yearSelect.disabled = true;

        fillNativeSelect(categorySelect, [], 'Produktkategorie auswählen');
        categorySelect.disabled = true;
        return;
      }

      if (current.make) {
        fillNativeSelect(modelSelect, getModels(current.make), 'Modell auswählen');
        modelSelect.disabled = false;
        modelSelect.value = current.model || '';
      } else {
        fillNativeSelect(modelSelect, [], 'Modell auswählen');
        modelSelect.disabled = true;
      }

      if (current.make && current.model) {
        fillNativeSelect(yearSelect, getYears(current.make, current.model), 'Jahr auswählen');
        yearSelect.disabled = false;
        yearSelect.value = current.tag || '';
      } else {
        fillNativeSelect(yearSelect, [], 'Jahr auswählen');
        yearSelect.disabled = true;
      }

      if (current.tag) {
        var nativeCategories = getCategories(current.tag);
        fillNativeSelect(
          categorySelect,
          nativeCategories,
          nativeCategories.length ? 'Produktkategorie auswählen' : 'Keine Kategorie verfügbar'
        );
        categorySelect.disabled = nativeCategories.length === 0;
        categorySelect.value = current.collectionHandle || '';
      } else {
        fillNativeSelect(categorySelect, [], 'Produktkategorie auswählen');
        categorySelect.disabled = true;
      }
    }

    function getMakes() {
      var makes = Object.keys(vehicleTree).sort(function(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      }).map(function(v) {
        return { value: v, label: v };
      });

      if (universalCategories.length) {
        makes.unshift({ value: UNIVERSAL_MAKE_VALUE, label: 'Universal' });
      }

      return makes;
    }

    function getModels(make) {
      if (!vehicleTree[make]) return [];

      return Object.keys(vehicleTree[make]).sort(function(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      }).map(function(v) {
        return { value: v, label: v };
      });
    }

    function getYears(make, model) {
      if (!vehicleTree[make] || !vehicleTree[make][model]) return [];

      return vehicleTree[make][model].map(function(year) {
        return {
          value: buildTag(make, model, year),
          label: year
        };
      });
    }

    function getCategories(vehicleTag) {
      var items = availability && availability.vehicles ? availability.vehicles[normalizeCollectionTag(vehicleTag)] : null;
      if (!Array.isArray(items)) return [];
      return items.filter(function(item) {
        return item && item.handle && item.slug && item.label && Number(item.productCount || 0) > 0;
      }).map(function(item) {
        return { value: item.handle, label: item.label, slug: item.slug, productCount: Number(item.productCount || 0) };
      });
    }

    function findCategoryByHandle(handle) {
      return availabilityByHandle[normalizeCollectionTag(handle)] || null;
    }

    function resetCategory(message) {
      current.categorySlug = '';
      current.categoryLabel = '';
      current.collectionHandle = '';
      if (categoryDd) {
        categoryDd.setValue('');
        categoryDd.setText(message || 'Produktkategorie auswählen');
        categoryDd.setItems([]);
        categoryDd.setDisabled(true);
      }
      if (categorySelect) {
        fillNativeSelect(categorySelect, [], message || 'Produktkategorie auswählen');
        categorySelect.disabled = true;
      }
    }

    function treeToRows(data) {
      var out = [];
      var makes = Object.keys(data || {});

      for (var i = 0; i < makes.length; i++) {
        var make = makes[i];
        var models = data[make] || {};
        var modelKeys = Object.keys(models);

        for (var j = 0; j < modelKeys.length; j++) {
          var model = modelKeys[j];
          var years = Array.isArray(models[model]) ? models[model] : [];

          for (var k = 0; k < years.length; k++) {
            var year = (years[k] || '').toString().trim();
            if (!make || !model || !year) continue;

            out.push({
              make: make,
              model: model,
              year: year,
              tag: buildTag(make, model, year)
            });
          }
        }
      }

      return out;
    }

    function findRowByTag(tag) {
      if (!tag) return null;
      tag = normalizeCollectionTag(tag);

      for (var i = 0; i < rows.length; i++) {
        if (rows[i].tag === tag) return rows[i];
      }

      return null;
    }

    function findProductVehicleTag() {
      if (!productTags || !productTags.length) return '';

      for (var i = 0; i < productTags.length; i++) {
        var cleanTag = slugify(productTags[i]);

        if (findRowByTag(cleanTag)) {
          return cleanTag;
        }
      }

      return '';
    }

    function extractTagFromQ(q) {
      q = (q || '').trim();
      if (q.indexOf('tag:') !== 0) return '';

      return q
        .substring(4)
        .replace(/^"|"$/g, '')
        .replace(/^'|'$/g, '')
        .trim();
    }

    function goSearch() {
      if (!current.tag || !current.make || !current.model || !current.year || !current.categorySlug || !current.collectionHandle) return;

      var selectedCategory = findCategoryByHandle(current.collectionHandle);
      if (!selectedCategory || selectedCategory.vehicleTag !== current.tag || Number(selectedCategory.productCount || 0) < 1) return;

      saveSelection();

      document.documentElement.classList.add('bt-loading-active');

      if (!document.querySelector('.bt-page-loading')) {
        document.body.insertAdjacentHTML(
          'beforeend',
          '<div class="bt-page-loading"><div class="bt-loader"></div></div>'
        );
      }

      window.location.href =
        '/collections/' + encodeURIComponent(current.collectionHandle) +
        '?bt_make=' + encodeURIComponent(current.make) +
        '&bt_model=' + encodeURIComponent(current.model) +
        '&bt_year=' + encodeURIComponent(current.year) +
        '&bt_tag=' + encodeURIComponent(current.tag) +
        '&bt_category=' + encodeURIComponent(current.categorySlug);
    }

    function enterUniversalMode() {
      isUniversalMode = true;
      current.make = '';
      current.model = '';
      current.year = '';
      current.tag = '';
      resetCategory();

      if (filterRow) filterRow.classList.add('bt-universal-mode');

      modelDd.setValue('');
      modelDd.setText('Kategorie auswählen');
      modelDd.setItems(universalCategories.map(function(item) {
        return { value: item.handle, label: item.label };
      }));
      modelDd.setDisabled(false);

      yearDd.setValue('');
      yearDd.setText('Jahr auswählen');
      yearDd.setItems([]);
      yearDd.setDisabled(true);

      if (searchBtn) searchBtn.disabled = true;
      syncNativeSelects();
    }

    function exitUniversalMode() {
      if (!isUniversalMode) return;
      isUniversalMode = false;
      if (filterRow) filterRow.classList.remove('bt-universal-mode');
    }

    function goUniversalSearch(handle) {
      if (!handle) return;

      document.documentElement.classList.add('bt-loading-active');

      if (!document.querySelector('.bt-page-loading')) {
        document.body.insertAdjacentHTML(
          'beforeend',
          '<div class="bt-page-loading"><div class="bt-loader"></div></div>'
        );
      }

      window.location.href = '/collections/' + encodeURIComponent(handle) + '?bt_universal=' + encodeURIComponent(handle);
    }

    var makeDd = createDropdown({
      wrapSelector: '.bt-dd[data-type="make"]',
      triggerSelector: '#btMakeTrigger-' + sid,
      menuSelector: '#btMakeMenu-' + sid,
      placeholder: 'Marke auswählen',
      onChange: function(value) {
        if (value === UNIVERSAL_MAKE_VALUE) {
          enterUniversalMode();
          setTimeout(function() { modelDd.open(); }, 30);
          return;
        }

        exitUniversalMode();

        current.make = value || '';
        current.model = '';
        current.year = '';
        current.tag = '';
        resetCategory();

        modelDd.setValue('');
        modelDd.setText('Modell auswählen');
        modelDd.setItems([]);
        modelDd.setDisabled(!value);

        yearDd.setValue('');
        yearDd.setText('Jahr auswählen');
        yearDd.setItems([]);
        yearDd.setDisabled(true);

        categoryDd.setItems([]);
        categoryDd.setDisabled(true);

        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();

        if (!value) return;

        modelDd.setItems(getModels(value));
        modelDd.setDisabled(false);

        setTimeout(function() {
          modelDd.open();
        }, 30);
      }
    });

    var modelDd = createDropdown({
      wrapSelector: '.bt-dd[data-type="model"]',
      triggerSelector: '#btModelTrigger-' + sid,
      menuSelector: '#btModelMenu-' + sid,
      placeholder: 'Modell auswählen',
      onChange: function(value, label) {
        if (isUniversalMode) {
          if (!value) {
            modelDd.setText('Kategorie auswählen');
            return;
          }

          modelDd.setText(label || 'Kategorie auswählen');
          goUniversalSearch(value);
          return;
        }

        current.model = value || '';
        current.year = '';
        current.tag = '';
        resetCategory();

        yearDd.setValue('');
        yearDd.setText('Jahr auswählen');
        yearDd.setItems([]);
        yearDd.setDisabled(!value);

        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();

        if (!current.make || !value) return;

        yearDd.setItems(getYears(current.make, value));
        yearDd.setDisabled(false);

        setTimeout(function() {
          yearDd.open();
        }, 30);
      }
    });

    var yearDd = createDropdown({
      wrapSelector: '.bt-dd[data-type="year"]',
      triggerSelector: '#btYearTrigger-' + sid,
      menuSelector: '#btYearMenu-' + sid,
      placeholder: 'Jahr auswählen',
      onChange: function(value, label) {
        current.tag = value || '';
        current.year = value ? label : '';
        resetCategory();

        var categories = getCategories(current.tag);
        categoryDd.setItems(categories);
        categoryDd.setDisabled(categories.length === 0);
        if (!categories.length && current.tag) categoryDd.setText('Keine Kategorie verfügbar');
        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();

        if (value) saveSelection();
        if (categories.length) setTimeout(function() { categoryDd.open(); }, 30);
      }
    });

    var categoryDd = createDropdown({
      wrapSelector: '.bt-dd[data-type="category"]',
      triggerSelector: '#btCategoryTrigger-' + sid,
      menuSelector: '#btCategoryMenu-' + sid,
      placeholder: 'Produktkategorie auswählen',
      onChange: function(value, label) {
        var selected = findCategoryByHandle(value);
        current.collectionHandle = selected ? selected.handle : '';
        current.categorySlug = selected ? selected.slug : '';
        current.categoryLabel = selected ? selected.label : (value ? label : '');
        if (searchBtn) searchBtn.disabled = !current.collectionHandle;
        syncNativeSelects();
        if (current.collectionHandle) {
          saveSelection();
          goSearch();
        }
      }
    });

    function applySelection(row, selectedCategory) {
      if (!row || !row.make || !row.model || !row.year || !row.tag) return false;
      if (!vehicleTree[row.make] || !vehicleTree[row.make][row.model]) return false;

      exitUniversalMode();

      var categories = getCategories(row.tag);
      var requestedHandle = selectedCategory ? (selectedCategory.handle || selectedCategory.value || '') : '';
      var requestedSlug = selectedCategory ? (selectedCategory.slug || '') : '';
      var availableCategory = categories.filter(function(item) {
        return (requestedHandle && item.value === requestedHandle) ||
          (!requestedHandle && requestedSlug && item.slug === requestedSlug);
      })[0] || null;
      var validatedCategory = availableCategory ? findCategoryByHandle(availableCategory.value) : null;

      if (validatedCategory && validatedCategory.vehicleTag !== row.tag) {
        validatedCategory = null;
      }

      current.make = row.make;
      current.model = row.model;
      current.year = row.year;
      current.tag = row.tag;
      current.categorySlug = validatedCategory ? validatedCategory.slug : '';
      current.categoryLabel = validatedCategory ? validatedCategory.label : '';
      current.collectionHandle = validatedCategory ? validatedCategory.handle : '';

      makeDd.setItems(getMakes());
      makeDd.setDisabled(false);
      makeDd.setValue(row.make);
      makeDd.setText(row.make);

      modelDd.setItems(getModels(row.make));
      modelDd.setDisabled(false);
      modelDd.setValue(row.model);
      modelDd.setText(row.model);

      yearDd.setItems(getYears(row.make, row.model));
      yearDd.setDisabled(false);
      yearDd.setValue(row.tag);
      yearDd.setText(row.year);

      categoryDd.setItems(categories);
      categoryDd.setDisabled(categories.length === 0);
      categoryDd.setValue(current.collectionHandle);
      categoryDd.setText(current.categoryLabel || (categories.length ? 'Produktkategorie auswählen' : 'Keine Kategorie verfügbar'));

      if (searchBtn) searchBtn.disabled = !current.collectionHandle;
      saveSelection();
      syncNativeSelects();
      persistCategoryContext();

      return true;
    }

    function restoreSelection() {
      var params = new URLSearchParams(window.location.search);

      var savedTag = (params.get('bt_tag') || '').trim();
      var savedCategory = (params.get('bt_category') || '').trim();
      var q = (params.get('q') || '').trim();
      var isProductPage =
        document.body.classList.contains('template-product') ||
        window.location.pathname.indexOf('/products/') !== -1;

      var collectionMatch = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
      var categoryFromPath = collectionMatch ? findCategoryByHandle(decodeURIComponent(collectionMatch[1] || '')) : null;
      if (categoryFromPath) {
        var rowFromCollection = findRowByTag(categoryFromPath.vehicleTag);
        if (rowFromCollection) {
          applySelection(rowFromCollection, categoryFromPath);
          return;
        }
      }

      if (!savedTag) {
        savedTag = extractTagFromQ(q);
      }

      if (savedTag) {
        var rowFromUrl = findRowByTag(savedTag);

        if (rowFromUrl) {
          var categoryFromUrl = getCategories(rowFromUrl.tag).filter(function(item) { return item.slug === savedCategory; })[0] || null;
          if (isProductPage && !savedCategory) {
            categoryFromUrl = inferProductCategory(rowFromUrl);
          }
          applySelection(rowFromUrl, categoryFromUrl);
          return;
        }
      }

      var saved = getSavedSelection();

      if (isProductPage && saved) {
        var rowFromProductStorage = findRowByTag(saved.tag);
        var categoryFromStorage = findCategoryByHandle(saved.collectionHandle || '');
        var hasSavedCategory = !!(saved.collectionHandle || saved.categorySlug);

        if (!categoryFromStorage && rowFromProductStorage && saved.categorySlug) {
          categoryFromStorage = getCategories(rowFromProductStorage.tag).filter(function(item) {
            return item.slug === saved.categorySlug;
          })[0] || null;
        }

        if (rowFromProductStorage &&
            categoryFromStorage &&
            productMatchesSelection(saved, categoryFromStorage)) {
          applySelection(rowFromProductStorage, categoryFromStorage);
          return;
        }

        if (rowFromProductStorage && !hasSavedCategory) {
          var inferredCategoryFromStorage = inferProductCategory(rowFromProductStorage);

          if (inferredCategoryFromStorage) {
            applySelection(rowFromProductStorage, inferredCategoryFromStorage);
            return;
          }
        }
      }

      var productVehicleTag = findProductVehicleTag();

      if (productVehicleTag) {
        var rowFromProduct = findRowByTag(productVehicleTag);

        if (rowFromProduct) {
          var inferredCategoryFromProduct = (!saved || !(saved.collectionHandle || saved.categorySlug))
            ? inferProductCategory(rowFromProduct)
            : null;
          applySelection(rowFromProduct, inferredCategoryFromProduct);
          return;
        }
      }

      if (!isProductPage) {
        if (saved) {
          var rowFromStorage = findRowByTag(saved.tag);

          if (rowFromStorage) {
            applySelection(rowFromStorage, findCategoryByHandle(saved.collectionHandle || ''));
            return;
          }
        }
      }

      current.make = '';
      current.model = '';
      current.year = '';
      current.tag = '';

      resetCategory();

      makeDd.setItems(getMakes());
      makeDd.setDisabled(false);
      makeDd.setValue('');
      makeDd.setText('Marke auswählen');

      modelDd.setItems([]);
      modelDd.setDisabled(true);
      modelDd.setValue('');
      modelDd.setText('Modell auswählen');

      yearDd.setItems([]);
      yearDd.setDisabled(true);
      yearDd.setValue('');
      yearDd.setText('Jahr auswählen');

      syncNativeSelects();
      if (searchBtn) searchBtn.disabled = true;
    }

    function resetAll() {
      exitUniversalMode();

      current.make = '';
      current.model = '';
      current.year = '';
      current.tag = '';
      resetCategory();

      clearSavedSelection();

      makeDd.setValue('');
      makeDd.setText('Marke auswählen');
      makeDd.setItems(getMakes());
      makeDd.setDisabled(false);

      modelDd.setValue('');
      modelDd.setText('Modell auswählen');
      modelDd.setItems([]);
      modelDd.setDisabled(true);

      yearDd.setValue('');
      yearDd.setText('Jahr auswählen');
      yearDd.setItems([]);
      yearDd.setDisabled(true);

      syncNativeSelects();
      if (searchBtn) searchBtn.disabled = true;
      closeAllDropdowns();

      var inputs = document.querySelectorAll(
        'input[type="search"], input[name="q"], .search__input, .search-input, .header__search input, .template-search input'
      );

      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value && inputs[i].value.indexOf('tag:') !== -1) {
          inputs[i].value = '';
        }
      }
    }

    function closeHeaderSearchPopup() {
      var closeButtons = document.querySelectorAll(
        '.predictive-search__close-button, .search-modal__close-button, .modal__close-button, button[aria-label="Schliessen"], button[aria-label="Close"]'
      );

      for (var i = 0; i < closeButtons.length; i++) {
        try { closeButtons[i].click(); } catch(e) {}
      }

      var details = document.querySelectorAll(
        'details[open], predictive-search[open], .search-modal[open]'
      );

      for (var j = 0; j < details.length; j++) {
        details[j].removeAttribute('open');
      }

      var popups = document.querySelectorAll(
        '.predictive-search, .predictive-search-results, .search-modal, .search__modal, .header__search details, .modal-overlay'
      );

      for (var k = 0; k < popups.length; k++) {
        popups[k].classList.remove('is-open', 'active', 'open');
      }
    }

    function cleanSearchBoxForVehicleSearch() {
      var params = new URLSearchParams(window.location.search);
      var hasVehicleSearch = params.get('bt_tag') || extractTagFromQ(params.get('q') || '');

      if (!hasVehicleSearch) {
        document.documentElement.classList.remove('bt-hide-vehicle-search-term');
        return;
      }

      var inputs = document.querySelectorAll(
        'input[type="search"], input[name="q"], .search__input, .search-input, .header__search input, .template-search input'
      );

      for (var i = 0; i < inputs.length; i++) {
        inputs[i].value = '';
        inputs[i].defaultValue = '';
        inputs[i].setAttribute('placeholder', 'Suchen');
        inputs[i].setAttribute('autocomplete', 'off');
        inputs[i].blur();
      }

      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }

      document.documentElement.classList.remove('bt-hide-vehicle-search-term');
    }

    function hideSearchTitleForVehicleSearch() {
      var params = new URLSearchParams(window.location.search);
      var hasVehicleSearch = params.get('bt_tag') || extractTagFromQ(params.get('q') || '');

      if (!hasVehicleSearch) return;

      var possibleTitles = document.querySelectorAll(
        'h1, h2, .template-search__header, .search-title, .search-results-title, .main-page-title, .collection-hero__title'
      );

      for (var i = 0; i < possibleTitles.length; i++) {
        var txt = (possibleTitles[i].textContent || '').trim().toLowerCase();

        if (txt === 'suchergebnisse' || txt === 'suchen' || txt.indexOf('suchergebnisse') !== -1) {
          possibleTitles[i].style.display = 'none';
        }
      }
    }

    function cleanVehicleSearchLayout() {
      cleanSearchBoxForVehicleSearch();
      hideSearchTitleForVehicleSearch();

      setTimeout(function(){
        cleanSearchBoxForVehicleSearch();
        hideSearchTitleForVehicleSearch();
      }, 0);

      setTimeout(function(){
        cleanSearchBoxForVehicleSearch();
        hideSearchTitleForVehicleSearch();
      }, 1000);
    }

    async function init() {
      try {
        makeDd.setItems([]);
        makeDd.setDisabled(true);

        var response = await fetch(DATA_URL, { cache: 'force-cache' });
        if (!response.ok) throw new Error('Fahrzeug-JSON konnte nicht geladen werden');

        var json = await response.json();
        vehicleTree = json || {};
        rows = treeToRows(vehicleTree);

        availability = { vehicles: {}, handles: {} };
        availabilityByHandle = {};
        try {
          var availabilityResponse = await fetch(AVAILABILITY_URL, { cache: 'no-cache' });
          if (!availabilityResponse.ok) throw new Error('Availability-Manifest HTTP ' + availabilityResponse.status);
          var availabilityJson = await availabilityResponse.json();
          if (!availabilityJson || availabilityJson.version !== 1 || !availabilityJson.vehicles || !availabilityJson.handles) {
            throw new Error('Availability-Manifest ist ungültig');
          }
          availability = availabilityJson;
          Object.keys(availability.vehicles).forEach(function(vehicleTag) {
            var categories = Array.isArray(availability.vehicles[vehicleTag]) ? availability.vehicles[vehicleTag] : [];
            categories.forEach(function(item) {
              if (!item || !item.handle || !item.slug || !item.label || Number(item.productCount || 0) < 1) return;
              var handleRecord = availability.handles[item.handle];
              if (!handleRecord || Number(handleRecord.productCount || 0) !== Number(item.productCount || 0)) {
                throw new Error('Availability-Manifest Handle ist inkonsistent: ' + item.handle);
              }
              if (availabilityByHandle[item.handle] && availabilityByHandle[item.handle].vehicleTag !== vehicleTag) {
                throw new Error('Availability-Manifest Handle ist mehrfach vergeben: ' + item.handle);
              }
              availabilityByHandle[item.handle] = {
                vehicleTag: vehicleTag,
                handle: item.handle,
                slug: item.slug,
                label: item.label,
                productCount: Number(item.productCount || 0)
              };
            });
          });
        } catch (availabilityError) {
          availability = { vehicles: {}, handles: {} };
          availabilityByHandle = {};
          console.error('Fahrzeugfilter Kategorien Fehler:', availabilityError);
        }

        restoreSelection();
        cleanVehicleSearchLayout();
      } catch (e) {
        console.error('Fahrzeugdaten Fehler:', e);

        makeDd.setItems([]);
        makeDd.setDisabled(true);

        modelDd.setItems([]);
        modelDd.setDisabled(true);

        yearDd.setItems([]);
        yearDd.setDisabled(true);

        categoryDd.setItems([]);
        categoryDd.setDisabled(true);

        if (searchBtn) searchBtn.disabled = true;
      }
    }

    document.addEventListener('click', function(e) {
      if (!root.contains(e.target)) {
        closeAllDropdowns();
      }
    });

    document.addEventListener('click', function(e) {
      var target = e.target;
      var productLink = target && target.closest ? target.closest('a[href*="/products/"]') : null;

      if (productLink) {
        decorateProductLink(productLink);
      }
    }, true);

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        root.classList.toggle('bt-filter-open');
      });
    }

    if (makeSelect) {
      makeSelect.addEventListener('change', function() {
        if (this.value === UNIVERSAL_MAKE_VALUE) {
          enterUniversalMode();
          return;
        }

        exitUniversalMode();

        current.make = this.value || '';
        current.model = '';
        current.year = '';
        current.tag = '';
        resetCategory();

        makeDd.setValue(current.make);
        makeDd.setText(current.make || 'Marke auswählen');

        modelDd.setValue('');
        modelDd.setText('Modell auswählen');
        modelDd.setItems(current.make ? getModels(current.make) : []);
        modelDd.setDisabled(!current.make);

        yearDd.setValue('');
        yearDd.setText('Jahr auswählen');
        yearDd.setItems([]);
        yearDd.setDisabled(true);

        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();
      });
    }

    if (modelSelect) {
      modelSelect.addEventListener('change', function() {
        if (isUniversalMode) {
          goUniversalSearch(this.value || '');
          return;
        }

        current.model = this.value || '';
        current.year = '';
        current.tag = '';
        resetCategory();

        modelDd.setValue(current.model);
        modelDd.setText(current.model || 'Modell auswählen');

        yearDd.setValue('');
        yearDd.setText('Jahr auswählen');
        yearDd.setItems(current.model ? getYears(current.make, current.model) : []);
        yearDd.setDisabled(!current.model);

        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();
      });
    }

    if (yearSelect) {
      yearSelect.addEventListener('change', function() {
        current.tag = this.value || '';
        current.year = current.tag ? this.options[this.selectedIndex].text : '';
        resetCategory();

        yearDd.setValue(current.tag);
        yearDd.setText(current.year || 'Jahr auswählen');

        var categories = getCategories(current.tag);
        categoryDd.setItems(categories);
        categoryDd.setDisabled(categories.length === 0);
        if (!categories.length && current.tag) categoryDd.setText('Keine Kategorie verfügbar');
        if (searchBtn) searchBtn.disabled = true;
        syncNativeSelects();

        if (current.tag) saveSelection();
      });
    }

    if (categorySelect) {
      categorySelect.addEventListener('change', function() {
        var selected = findCategoryByHandle(this.value || '');
        current.collectionHandle = selected ? selected.handle : '';
        current.categorySlug = selected ? selected.slug : '';
        current.categoryLabel = selected ? selected.label : '';

        categoryDd.setValue(current.collectionHandle);
        categoryDd.setText(current.categoryLabel || 'Produktkategorie auswählen');
        if (searchBtn) searchBtn.disabled = !current.collectionHandle;
        if (current.collectionHandle) {
          saveSelection();
          goSearch();
        }
      });
    }

    if (searchBtn) {
      searchBtn.addEventListener('click', function() {
        goSearch();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        resetAll();
      });
    }


    /* Reset nur wenn Startseite / Home / Logo geklickt wird */
    var homeLinks = document.querySelectorAll(
      'a[href="/"], a[href="' + (config.rootUrl || '/') + '"], a[href="' + window.location.origin + '/"]'
    );

    for (var h = 0; h < homeLinks.length; h++) {
      homeLinks[h].addEventListener('click', function() {
        clearSavedSelection();
      });
    }

    init();
  };

  namespace.initAll = function(scope) {
    var root = scope || document;
    var scripts = root.querySelectorAll('script[id^="btVehicleFilterConfig-"]');

    for (var i = 0; i < scripts.length; i++) {
      namespace.init(parseConfig(scripts[i]));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", function() {
      namespace.initAll(document);
    });
  } else {
    namespace.initAll(document);
  }
})();
